export default class Permessi {
    static permessiLoaded = false;
    static permessoIncassi = false;
    static permessoArtven = false;
    static permessoContrdoc = false;
    static permessoVerart = false;
    static permessoGestord = false;
}
